/**
 * PoppinPay API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The OrderQueueResultModel model module.
* @module model/OrderQueueResultModel
* @version 1.0.0
*/
export default class OrderQueueResultModel {
    /**
    * Constructs a new <code>OrderQueueResultModel</code>.
    * @alias module:model/OrderQueueResultModel
    * @class
    */

    constructor() {
        
        
        
    }

    /**
    * Constructs a <code>OrderQueueResultModel</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/OrderQueueResultModel} obj Optional instance to populate.
    * @return {module:model/OrderQueueResultModel} The populated <code>OrderQueueResultModel</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new OrderQueueResultModel();
                        
            
            if (data.hasOwnProperty('IdempotencyKey')) {
                obj['IdempotencyKey'] = ApiClient.convertToType(data['IdempotencyKey'], 'String');
            }
        }
        return obj;
    }

    /**
    * @member {String} IdempotencyKey
    */
    'IdempotencyKey' = undefined;




}
